import {VALIDATION_PATTERNS} from '../../../../../constants/validation.patterns.constants';
import VIEW_MODES from '../../../../../core/enums/view-modes.types';
import AqlQueryModel from '../../../../../core/models/distribution/AqlQueryModel';
import UserFriendlyQueryModel from '../../../../../core/models/distribution/UserFriendlyQueryModel';
import ViewHelpers from '../../../../../core/utils/view.helpers';
import SignBundleVersionService from '../../../../../services/signBundleVersionService/sign.bundle.version.service';
import ValidationsService from '../../../../../services/validations.service';
import BundleVersionComponent from '../version/bundle.version.component';
import AqlQueryCreateEditService from './aqlQueryCreateEditService/aql.query.create.edit.service';
import BundleCreationDryRunService from './bundleCreationDryDunService/bundle.creation.dry.run.service';
import CreateBundleDAO from './DAO/CreateBundleDAO';

export default class CreateBundleController {

	constructor($state, $stateParams, $scope, JFrogTableViewOptions, JFrogEventBus, JFrogModal, validationsService,
	            aqlQueryCreateEditService, createBundleDAO, JFrogNotifications,
	            BundleCreationDryRunService, signBundleVersionService, JFrogUIModelSaverFactory, AppStack) {
		this.$state = $state;
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.appStack = AppStack;
		this.validationsService = validationsService;
		this.JFrogTableViewOptions = JFrogTableViewOptions;
		this.aqlQueryCreateEditService = aqlQueryCreateEditService;
		this.createBundleResource = createBundleDAO.Resource;
		this.createBundleJson = {};
		this.VIEW_MODES = VIEW_MODES;
		this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
		this.JFrogModal = JFrogModal;
		this.JFrogNotifications = JFrogNotifications;
		this.bundleCreationDryRunService = BundleCreationDryRunService;
		this.signBundleVersionService = signBundleVersionService;
		this.ViewHelpers = ViewHelpers;
		this.namePattern = VALIDATION_PATTERNS.CREATE_BUNDLE.BUNDLE_NAME;
		this.versionPattern = VALIDATION_PATTERNS.CREATE_BUNDLE.BUNDLE_VERSION;
		this.JFrogUIModelSaverFactory = JFrogUIModelSaverFactory;
	}

	$onInit() {
		this.formSubmitAction = this.getFormSubmitAction();
		this.createReleaseBundleModel = this.bundle;
		this.initAqlQueriesTable();
		this.JFrogUIModelSaver = this.JFrogUIModelSaverFactory.createInstance(this, ['createReleaseBundleModel']);
		if (this.viewMode === this.VIEW_MODES.EDIT) {
			this.daoQueryParams = {
				release_bundle: this.createReleaseBundleModel.name,
				release_bundle_version: this.createReleaseBundleModel.version
			};
		}
	}

	showSpinner() {
        window.store.dispatch('ENABLE_LOCAL_LOADER','.create-bundles-form-container');
    }

	hideSpinner() {
        window.store.dispatch('DISABLE_LOCAL_LOADER','.create-bundles-form-container');
    }

	getSubmitButtonText() {
		return `${(this.viewMode === this.VIEW_MODES.EDIT ? 'Save' : 'Create')}`;
	}

	getPageTitle() {
		return `${(this.viewMode === this.VIEW_MODES.EDIT ? 'Edit' : 'New')} Release Bundle`;
	}

	getFormSubmitAction() {
		//TODO: replace ths daoParams acording to viewMode
		return this.viewMode === this.VIEW_MODES.EDIT ?
			this.createBundleResource.updateReleaseBundle : this.createBundleResource.createReleaseBundle;
	}

	initQueryActionsDropdown() {
		if (!this.quickActions) {
			return;
		}
		this.quickActions.setActionsDictionary(this.getQueryActionsDictionary());
		this.quickActions.setActions(this.getQueryActions());
	}

	initQuickActions(actionsController) {
		this.quickActions = actionsController;
		this.initQueryActionsDropdown();
	}

	getQueryActionsDictionary() {
		let dictionary = {};
		dictionary.addSimple = {title: 'Add Query'};
		dictionary.addAdvanced = {title: 'Add AQL Query'};
		return dictionary;
	}

	getQueryActions() {
		let actions = [{
			name: 'addSimple',
			icon: 'bordered',
			action: () => {
				this.addNewUserFriendlyQuery();
			}
		}, {
			name: 'addAdvanced',
			icon: 'bordered',
			action: () => {
				this.addNewQuery();
			}
		}];
		return actions;
	}

	initAqlQueriesTable() {
		this.tableViewOptions = new this.JFrogTableViewOptions(this.$scope);
		this.tableViewOptions
		    .setColumns(this.getAqlQueriesColumns())
		    .setActions(this.getActions())
		    .setRowsPerPage(10)
		    .setEmptyTableText(`No Queries.`)
		    .setEmptyTableCallToAction('Click to Add a New Query')
		    .setEmptyTableAction(() => {
			    this.addNewUserFriendlyQuery();
		    })
		    .setObjectName('Aql Query')
		    .showFilter(false)
		    .showCounter(false)
		    .setData(this.createReleaseBundleModel.spec.queries)
		    .on('row.clicked', (row, $event) => {
			    if (!row || !row.entity) {
				    return;
			    }
			    this.editQuery(row.entity, $event);
		    });
	}

	refreshTableData() {
		this.tableViewOptions.setData(this.createReleaseBundleModel.spec.queries);
	}

	getAqlQueriesColumns() {
		return [{
			field: 'query_name',
			header: 'Name',
			width: '15%'
		}, {
			field: 'aql',
			header: 'Query',
			width: '50%',
			filterable: false,
			cellTemplate: require('./cellTemplates/query.cell.template.view.html')
		}];
	}

	isFriendlyQuery(tableRow) {
		return tableRow && tableRow.release_bundle_query_fields &&
			(tableRow.release_bundle_query_fields.repositories.length ||
				tableRow.release_bundle_query_fields.builds ||
				tableRow.release_bundle_query_fields.search_properties);
	}

	addNewQuery() {
		this.aqlQueryCreateEditService
		    .showAqlQueryModal(new AqlQueryModel({}),
			    (query) => {
				    this.createReleaseBundleModel.spec.queries.push(query);
				    this.refreshTableData();
			    },
			    this.VIEW_MODES.CREATE,
			    this.createReleaseBundleModel.spec, false);
	}

	addNewUserFriendlyQuery() {
		this.aqlQueryCreateEditService
		    .showAqlQueryModal(new AqlQueryModel({
				    release_bundle_query_fields: new UserFriendlyQueryModel({})
			    }),
			    (query) => {
				    this.createReleaseBundleModel.spec.queries.push(query);
				    this.refreshTableData();
			    },
			    this.VIEW_MODES.CREATE,
			    this.createReleaseBundleModel.spec,
			    true);
	}

	editQuery(queryToEdit) {
		this.aqlQueryCreateEditService
		    // New AqlQueryModel entity to prevent from changes to happen before saving (binding)
		    .showAqlQueryModal(new AqlQueryModel(queryToEdit),
			    (query) => {
				    _.extend(queryToEdit, query);
			    },
			    this.VIEW_MODES.EDIT,
			    this.createReleaseBundleModel.spec,
			    queryToEdit.release_bundle_query_fields);
	}

	getActions() {
		return [
			{
				icon: 'icon icon-edit-pen',
				tooltip: 'Edit',
				callback: (row) => {
					this.editQuery(row);
				}
			}, {
				icon: 'icon icon-clear red',
				tooltip: 'Delete',
				callback: (row) => {
					this.JFrogModal
					    .confirm(`Delete query ${row.query_name} ?`,
						    'Delete Query', {confirm: 'Delete'})
					    .then(() => {
						    this.seekAndDestroy(row);
						    this.refreshTableData();
					    });
				}
			}
		];
	}

	seekAndDestroy(item) {
		if (!item || !item.query_name) {
			return;
		}
		let index = _.findIndex(this.createReleaseBundleModel.spec.queries, q => q.query_name === item.query_name);
		if (index >= 0) {
			this.createReleaseBundleModel.spec.queries.splice(index, 1);
		}
	}

	isValidForm() {
		// Has to have name , version and at least one query
		return this.createReleaseBundleForm.$valid &&
			this.createReleaseBundleModel.spec &&
			this.createReleaseBundleModel.spec.queries &&
			this.createReleaseBundleModel.spec.queries.length > 0;
	}

	jfOnBeforeFormSubmit() {
	    this.showSpinner();
		this.createBundleJson = this.createReleaseBundleModel.build();
		this.JFrogUIModelSaver.save();
	}

	onFormSubmitSuccess() {
		const params = {
			bundle: this.createReleaseBundleModel.name,
			version: this.createReleaseBundleModel.version,
			tab: 'content'
		};
        window.$vueRouter.push({
            name: 'singleVersion',
            params,
        });
		this.hideSpinner();
	}

	onFormSubmitFailure(response) {
		this.createReleaseBundleModel.sign_immediately = false;
        this.hideSpinner();
    }

	onDryRun() {
		this.bundleCreationDryRunService.dryRun(this.createReleaseBundleModel);
	}

	clearAlreadyExistValidation() {
		if (this.createReleaseBundleForm
			&& this.createReleaseBundleForm.version
			&& this.createReleaseBundleForm.version.$error
			&& this.createReleaseBundleForm.version.$error['already.exists']) {
			this.createReleaseBundleForm.version.$setValidity('already.exists', true);
		}
	}

	submitSignedBundle() {
		this.signBundleVersionService.signBundleVersion({
			release_bundle: this.createReleaseBundleModel.name,
			release_bundle_version: this.createReleaseBundleModel.version
		}, (passPhrase) => {
			if(passPhrase) {
				// Add passphrase to header if passed
				this.getFormSubmitAction().setHeaders('X-GPG-PASSPHRASE', passPhrase);
			}
			this.createReleaseBundleModel.sign_immediately = true;
			this.onSubmit();
			this.getFormSubmitAction().removeHeaders();
		});
	}

	getPrevRoute() {
        const { $stateParams } = this;
        const { params } = window.$vueRouter.currentRoute;
        const prevUrl = (($stateParams && $stateParams.prevUrl) || (params && params.prevUrl));
        if (prevUrl)  {
            return { path: prevUrl };
        }
        const routes = window.store.getters["distribution/GET_ROUTE_CONSTANTS"];
        return {
            name: routes.DISTRIBUTION_MAIN,
            params: { activeTab: routes.DISTRIBUTION_MAIN_TABS.SOURCE }
        };
    }

    onBack() {
	    window.$vueRouter.push(this.getPrevRoute());
    }
}

CreateBundleController.$inject = [
	'$state',
	'$stateParams',
	'$scope',
	'JFrogTableViewOptions',
	'JFrogEventBus',
	'JFrogModal',
	ValidationsService.META.name,
	AqlQueryCreateEditService.META.name,
	CreateBundleDAO.META.name,
	'JFrogNotifications',
	BundleCreationDryRunService.META.name,
	SignBundleVersionService.META.name,
	'JFrogUIModelSaverFactory',
	'AppStack'
];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/bundle.create.controller.js